/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { CommunityFocus } from './communityFocus';
import { CommunityStatus } from './communityStatus';
import { LocationObject } from './locationObject';
import { UserBasic } from './userBasic';
import { UserRelationToGroup } from './userRelationToGroup';

export interface CommunityBasic { 
    entity_id: string;
    title: string;
    type: string;
    focus: CommunityFocus;
    key_categories: Array<CategoryBasicView>;
    location: LocationObject;
    creator: UserBasic;
    created: Date;
    status: CommunityStatus;
    actor_role: UserRelationToGroup;
}